import TagManager from "react-gtm-module";

export const gtmEvent = ({ event, ...props }) => {
  TagManager.dataLayer({
    dataLayer: {
      event,
      page: window.location.href,
      ...props,
    },
  });
};
